import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { useEffect, useState } from 'react';
import SystemLabel from '../../components/Systemlabel/SystemLabel';

export default function Printer(props) {
  const [startTimeout, setStartTimeout] = useState(false);
  const [failed, setFailed] = useState(false);
  const { environment, orders, settings } = props;
  const { eventId, lang } = environment;
  const { redirectUrl, defaultStation, timeout = 30, checkIn = false } = settings;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const station = params.get('station') ?? defaultStation;
    const badgeNo = orders?.[0]?.badgeNo;

    if (station && eventId && badgeNo) {
      print(badgeNo, station, eventId, checkIn);
    }
  }, [eventId, window.location.search, orders, checkIn, defaultStation]);

  const onPrint = status => {
    if (!status) setFailed(true);
    setStartTimeout(true);
  };

  const print = (badgeNo, station, eventId, checkIn) => {
    const hubConnection = new HubConnectionBuilder().withAutomaticReconnect().withUrl('/onsitehub').build();

    hubConnection.start().then(() => {
      hubConnection.on('onPrint', onPrint);
      hubConnection.invoke('print', badgeNo, station, eventId, checkIn, 'SELF_REG', false);
    });
  };

  useEffect(() => {
    if (startTimeout && redirectUrl) {
      const params = new URLSearchParams(window.location.search);
      const station = params.get('station') ?? defaultStation;
      const languageCode = params.get('languageCode') ?? lang ?? 'swe';
      const queryParams = { languageCode, station };

      const timer = setTimeout(() => {
        const queryString = Object.keys(queryParams)
          .map(key => key + '=' + encodeURIComponent(queryParams[key]))
          .join('&');
        window.location.href = `${redirectUrl}${queryString ? '?' + queryString : ''}`;
        clearTimeout(timer);
      }, timeout * 1000);
    }
  }, [startTimeout, timeout, redirectUrl, lang]);

  if (failed) {
    return (
      <Alert severity="error">
        <AlertTitle>
          <SystemLabel name="PrintFailed" />
        </AlertTitle>
        <SystemLabel name="ContactStaffForMoreInformation" />
      </Alert>
    );
  }

  return null;
}
